var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.25,0H1.75A1.752,1.752,0,0,0,0,1.75v4.5A1.752,1.752,0,0,0,1.75,8h7.5A1.752,1.752,0,0,0,11,6.25V1.75A1.752,1.752,0,0,0,9.25,0Zm0,0",
    fill: "#8f43ee"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25,213.332H1.75A1.752,1.752,0,0,0,0,215.082v10.5a1.752,1.752,0,0,0,1.75,1.75h7.5a1.752,1.752,0,0,0,1.75-1.75v-10.5A1.752,1.752,0,0,0,9.25,213.332Zm0,0",
    transform: "translate(0 -203.332)",
    fill: "#8f43ee"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M286.582,341.332h-7.5a1.752,1.752,0,0,0-1.75,1.75v4.5a1.752,1.752,0,0,0,1.75,1.75h7.5a1.752,1.752,0,0,0,1.75-1.75v-4.5A1.752,1.752,0,0,0,286.582,341.332Zm0,0",
    transform: "translate(-264.332 -325.332)",
    fill: "#8f43ee"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M286.582,0h-7.5a1.752,1.752,0,0,0-1.75,1.75v10.5a1.752,1.752,0,0,0,1.75,1.75h7.5a1.752,1.752,0,0,0,1.75-1.75V1.75A1.752,1.752,0,0,0,286.582,0Zm0,0",
    transform: "translate(-264.332)",
    fill: "#8f43ee"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.a329a3c7e45b1c72283386d36d77bffd.svg";
export { ForwardRef as ReactComponent };